import styled from 'styled-components';

import { StyledComponent } from '../../../types/styledComponent.types';

export const Container: StyledComponent<'div'> = styled.div``;
